export const BRAND = {
  name: 'The Scrappy Marketer',
  founder: 'Waela Fellnert',
  email: 'contact@thescrappysupport.com',
  linkedin: 'https://www.linkedin.com/in/waela-fellnert/',
  x: 'https://x.com/_waela',
};

export const SOCIAL = {
  linkedin: BRAND.linkedin,
  x: BRAND.x,
};

export const SOCIALS = [
  { label: 'LinkedIn', href: BRAND.linkedin },
  { label: 'X', href: BRAND.x },
];

export const IMAGES = {
  heroBg: 'https://static.prod-images.emergentagent.com/jobs/d3676084-eaa5-4a87-9471-981e8c79b086/images/761329be2ea71c22ca6a3675aca14b19b713859a0f60ef8ed5265797252da9f1.png',
  workspace: 'https://static.prod-images.emergentagent.com/jobs/d3676084-eaa5-4a87-9471-981e8c79b086/images/80a55dfa485f02ba477768cc54fbb3deb9e465cddaaf435b0cbf53acea7d0d0d.png',
  portrait: 'https://customer-assets.emergentagent.com/job_founder-ops-9/artifacts/njjl695w_171749849843382796.jpeg',
  desk: 'https://images.unsplash.com/photo-1770899621442-24237af4c8b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwZGVzayUyMHdvcmtzcGFjZSUyMHdhcm0lMjBsaWdodGluZ3xlbnwwfHx8fDE3Nzg1ODU3MjF8MA&ixlib=rb-4.1.0&q=85',
  startup: 'https://customer-assets.emergentagent.com/job_founder-ops-9/artifacts/c5sivsqb_Waela%20looking%20at%20the%20computer.png',
};

export const MAILTO_BASE = `mailto:${BRAND.email}`;
